<template>
  <!--参会指南-->
  <div class="guide">
    <Row>
      <div v-for="(list,index) in dataInfo" :key="index">
          <i-col :span="col">
            <h3 class="title">{{index+1}}、{{list.title}}</h3>
            <div v-for="(item,index) in list.data" :key="index">
              <p class="title sub-title">{{item.label}}</p>
              <div v-for="(info,index) in item.info" :key="index">
                <p class="label">{{info}}</p>
              </div>
            </div>
          </i-col>
      </div>
    </Row>
  </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
          dataInfo:{
              type: Array
          },
          col:{
              type: Number
          }
        },
        computed:{
        },
        methods: {},
        created(){

        },
        ready(){

        }
    }
</script>
<style scoped>
  .guide{
    color: #000;
    line-height: 1.8;
    padding: 17px 0 0 0;
  }
  .title{
    font-weight: 600;
    font-size: 18px;
  }
  .sub-title{
    margin-left: 10px;
  }
  .label{
    margin-left: 15px;
    width: 140px;
    word-break: break-all;
    font-weight: 400;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// iGuide.vue?0809ba00